<template>
  <div class="yhMemberActivitiesManageAdd">
    <el-card>
      <div class="jump-btn">
        <!-- 返回活动管理 -->
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backActivity')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" class="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_garden')" prop="gardenId" v-if="id">
          <el-select v-model="form.gardenId" class="select">
            <el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 全局小区为全部小区时所属小区 -->
        <el-form-item label="所属项目" prop="gardenIds" v-else>
          <el-select v-model="form.gardenIds" multiple @change="change" class="select" clearable filterable>
            <el-option key :label="$t('lang.villageall')" :value='0'></el-option>
            <el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 活动名称 -->
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="form.name" :placeholder="$t('lang.key_name')" class="input"></el-input>
        </el-form-item>
        <!-- 活动核销码 -->
        <!-- <el-form-item label="活动核销码" prop="cerCode" v-if="this.id">
          <el-input v-model="form.cerCode" disabled class="input"></el-input>
        </el-form-item> -->
        <!-- 活动图片 -->
        <el-form-item label="活动图片" prop="image" ref="image">
          <template slot="label">
            活动图片
            <el-tooltip placement="top" content="建议图片宽高比2:1">
              <i class="el-icon-warning" style="margin-left: 5px; cursor: pointer;"></i>
            </el-tooltip>
          </template>
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears'
            @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
        <!-- 活动开始、截止时间 -->
        <el-form-item label="活动时间" prop="beginTime">
          <div class="block">
            <el-date-picker v-model="beginTimeList" :format="$t('lang.lab_DATA')" value-format="yyyy-MM-dd"
              type="daterange" :range-separator="$t('lang.lab_to')" :start-placeholder="$t('lang.lab_startDate')"
              :end-placeholder="$t('lang.lab_endDate')" :picker-options="pickerOptions0"
              class="date-picker-width">
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- 报名截止时间 -->
        <el-form-item label="报名截止时间" prop="closeTime">
          <div class="block">
            <el-date-picker v-model="form.closeTime" type="date" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions0" :format="$t('lang.lab_DATA')" :placeholder="$t('lang.lab_closeTime')"
              class="date-picker-width">
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- 活动地点 -->
        <el-form-item label="活动地点" prop="place">
          <el-input v-model="form.place" :placeholder="$t('lang.key_place')" class="input"></el-input>
        </el-form-item>
        <!-- 电话号码 -->
        <el-form-item label="电话号码" prop="telephone">
          <el-input v-model="form.telephone" :placeholder="$t('lang.key_tekephone')" class="input" maxlength="30"
            @input="handleInput('telephone', 'phone', $event)"></el-input>
        </el-form-item>
        <!-- 总人数上限 -->
        <el-form-item label="总人数上限" prop="totalNum">
          <el-input v-model="form.totalNum" :placeholder="$t('lang.key_totalNum')" class="input" @input="handleInput('totalNum', 'number', $event)"
            maxlength="6"></el-input>
        </el-form-item>
        <!-- 活动所需积分 -->
        <el-form-item label="活动所需积分" prop="activityPoint">
          <el-input v-model="form.activityPoint" placeholder="请输入活动所需积分" class="input" maxlength="4" @input="handleInput('activityPoint', 'number', $event)">
          </el-input>
        </el-form-item>
        <!-- 活动所需费用 -->
        <el-form-item label="活动所需费用" prop="activityMoney">
          <el-input v-model="form.activityMoney" placeholder="请输入活动所需费用" class="input" maxlength="4" @input="handleInput('activityMoney', 'activityMoney', $event)">
          </el-input>
        </el-form-item>
        <!-- 活动详情 -->
        <el-form-item label="活动详情" prop="content">
          <!-- 富文本 -->
          <quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span
            class="editorText">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
        </el-form-item>
        <el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="onSubmit('form')" class="detailbtn" :disabled="isDisabled">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// 引入富文本功能键tooltip效果
import UploadFile from '../../../components/upload_file.vue'
import { addQuillTitle } from '../../../config/quill-title.js'

export default {
  data() {
    // 正则表达式
    const positiveIntegerWithoutZero = /^[0-9]*[1-9][0-9]*$/
    const phoneRegex = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    const positiveDecimal = /^[1-9]\d*(\.\d{1,2})?$|^0\.(?!00)\d{1,2}$/
    // 验证函数
    const validatePhone = (rule, value, callback) => {
      if (value !== '' && !phoneRegex.test(value)) {
        callback(new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue')))
      } else {
        callback()
      }
    }
    const validateImage = (rule, value, callback) => {
      if (this.form.image === '') {
        callback(new Error(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc')))
      } else {
        callback()
      }
    }
    const validateBeginTime = (rule, value, callback) => {
      if (this.beginTimeList.length < 2) {
        callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_beginTime')))
      } else {
        callback()
      }
    }
    const validateGardenIds = (rule, value, callback) => {
      if (this.form.gardenIds.length < 1) {
        callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.lab_garden')))
      } else {
        callback()
      }
    }
    const validateCost = (rule, value, callback) => {
      if (value === '' || value == null) {
        callback()
      } else if (!positiveDecimal.test(value) || Number(value) <= 0) {
        callback(new Error('费用必须是大于0的正数，最多保留2位小数'))
      } else {
        callback()
      }
    }

    return {
      clears: false, // 清空按钮
      accept: '.jpg, .jpeg, .png',
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }, // 当前时间
      saveData: '',
      id: '', // 区分新增和修改
      oldsearchUnit: [], // 复选输入框change前的数据
      pageNum: 1, // 页数
      pageSize: 10, // 一页显示数
      isDisabled: true, // 置灰标识
      tableData: [], // 列表
      isLength: 0, // 长度
      gardenList: [], // 下拉列表
      value: '0', // 绑定值
      input: '', // input绑定值
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'], // 引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: 'ordered' }, { list: 'bullet' }], // 列表
            [{ script: 'sub' }, { script: 'super' }], // 上下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ direction: 'rtl' }], // 文本方向
            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], // 字体
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除字体样式
            ['image', 'video'] // 上传图片、上传视频
          ]
        },
        theme: 'snow',
        placeholder: '请输入活动详情...',

      }, // 富文本
      form: {
        gardenIds: [],
        gardenId: '', // 项目id
        image: '', // 活动图片
        name: '', // 活动名称
        content: '', // 活动详情
        beginTime: '', // 活动开始时间
        endTime: '', // 活动截止时间
        place: '', // 活动地点
        totalNum: '', // 总人数上限
        activityPoint: '', // 活动所需积分
        activityMoney: '', // 费用
        telephone: '', // 联系电话
        closeTime: '', // 报名截止时间
      }, // 对象
      beginTimeList: [], // 开始时间
      fileList: [], // fileList
      rules: {
        gardenId: [{
          required: true,
          message: this.$i18n.t('lang.lab_chooseGarden'),
          trigger: 'change'
        }],
        gardenIds: [{
          required: true,
          validator: validateGardenIds,
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: this.$i18n.t('lang.key_name'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: this.$i18n.t('lang.lab_InputcontentNotice'),
          trigger: 'blur'
        }],
        place: [{
          required: true,
          message: this.$i18n.t('lang.key_place'),
          trigger: 'blur'
        }],
        closeTime: [{
          required: true,
          message: this.$i18n.t('lang.lab_closeTime'),
          trigger: 'blur'
        }],
        image: [{
          required: true,
          validator: validateImage,
          trigger: 'blur'
        }],
        beginTime: [{
          required: true,
          validator: validateBeginTime,
          trigger: 'blur'
        }],
        telephone: [{
          required: false,
          validator: validatePhone,
          trigger: 'blur'
        }],
        totalNum: [{
          required: false,
          pattern: positiveIntegerWithoutZero,
          message: '请输入正整数',
          trigger: 'blur'
        }],
        activityPoint: [{
          required: false,
          pattern: positiveIntegerWithoutZero,
          message: '请输入正整数',
          trigger: 'blur'
        }],
        // 添加费用验证（非必填）
        activityMoney: [{
          required: false,
          validator: validateCost,
          trigger: 'blur'
        }]
      } // 表单验证
    }
  },
  components: {
    'upload-file': UploadFile
  },
  destroyed() {
    window.localStorage.setItem('yhAddActivityManagementform', JSON.stringify(this.form))
    window.localStorage.setItem('yhAddActivityManagementsaveData', JSON.stringify(this.saveData))
  },
  created() {
    this.id = this.$route.query.id
    this.initData()
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 初始化数据
    initData() {
      // 尝试从本地存储加载数据
      const savedForm = window.localStorage.getItem('yhAddActivityManagementform')
      const savedSaveData = window.localStorage.getItem('yhAddActivityManagementsaveData')

      if (savedForm) {
        this.form = JSON.parse(savedForm)
        if (this.form.image) {
          this.fileList.push({ name: '', url: this.form.image })
        }
        if (savedSaveData) {
          this.saveData = JSON.parse(savedSaveData)
        }
      } else if (this.id) {
        // 如果是编辑模式且没有本地存储数据，则从服务器获取
        this.activityById()
      }
      // 加载小区列表
      this.loadGardenList()
    },

    // 加载小区列表
    loadGardenList() {
      if (this.id) {
        // 编辑模式下过滤掉"全部小区"
        let gardenList = [...this.$store.getters.userGardenList]
        const index = gardenList.findIndex(item => item.id === 0)
        if (index !== -1) {
          gardenList.splice(index, 1)
        }
        this.gardenList = gardenList
      } else {
        // 新增模式下加载所有小区
        this.gardens()
      }
    },
    // 获取组件值
    getFile(e) {
      this.form.image = e
      this.$refs.image.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.form.image = ''
    },
    // 内容字数提示
    onEditorChange(event) {
      event.quill.deleteText(10000, 4)
      if (this.form.content == '') {
        this.isLength = 0
      } else {
        this.isLength = event.quill.getLength() - 1
      }
      this.manualValidate()
    },
    // 富文本验证
    manualValidate() {
      this.$refs.form.validateField('content')
    },
    // 通用输入处理函数
    handleInput(field, type = 'number', value) {
      console.log(`handleInput方法被调用 - 字段: ${field}, 类型: ${type}, 值: ${value}`)
      
      if (type === 'number') {
        console.log(`处理数字输入 - 字段: ${field}, 值: ${value}`)
        // 仅保留数字
        value = value.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (value && !value.includes('.')) {
          value = parseFloat(value).toString()
        }
      } else if (type === 'phone') {
        console.log(`处理电话输入 - 字段: ${field}, 值: ${value}`)
        // 仅保留数字
        value = value.replace(/[^\d]/g, '')
        // 限制长度为11位
        if (value.length > 11) {
          value = value.slice(0, 11)
        }
      } else if (type === 'activityMoney') {
        console.log(`处理费用输入 - 字段: ${field}, 值: ${value}`)
        // 仅保留数字和小数点
        value = value.replace(/[^\d.]/g, '')
        // 处理多个小数点
        value = value.replace(/\.{2,}/g, '.')
        value = value.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
        // 首位是0的话去掉
        if (value && !value.includes('.')) {
          value = parseFloat(value).toString()
        }
      }
      this.form[field] = value
    },
    // 活动详情
    activityById() {
      let loading = this.$loading()
      this.$get(`/gardenShopActivityById/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form = res.activity
            this.beginTimeList.push(this.form.beginTime)
            this.beginTimeList.push(this.form.endTime)
            if (res.activity.image && res.activity.image != '') {
              this.fileList.push({
                name: '',
                url: res.activity.image.toString()
              })
            }
            this.form.gardenId = res.activity.gardenId
            this.saveData = JSON.stringify(this.form)
          }
        },
        error => {
          this.handleError(loading, error)
        }
      )
    },
    // 选择全部小区
    change(val) {
      // 获取所有小区ID（不含全选0）
      const allGardenIds = this.gardenList.map(item => item.id)
      // 保存当前选择的值作为下次的老数据
      const oldVal = [...this.oldsearchUnit[0] || []]
      // 更新当前值
      this.oldsearchUnit[0] = [...val]
      // 若选择全部小区
      if (val.includes(0)) {
        this.form.gardenIds = [0, ...allGardenIds]
        return
      }
      // 取消全选
      if (oldVal.includes(0) && !val.includes(0)) {
        this.form.gardenIds = []
        return
      }
      // 已选择所有小区（不含全选），则自动勾选全选
      if (val.length === allGardenIds.length) {
        this.form.gardenIds = [0, ...allGardenIds]
      } else {
        this.form.gardenIds = [...val]
      }
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.gardenList = res.list
          }
        },
        error => {
          this.handleError(loading, error)
        }
      )
    },
    // 重置表单
    rest(form) {
      this.fileList = []
      this.clears = true
      this.$refs.form.clearValidate()
      this.beginTimeList = []
      this.form = {
        gardenIds: [],
        gardenId: '',
        image: '',
        name: '',
        content: '',
        beginTime: '',
        endTime: '',
        place: '',
        totalNum: '',
        activityPoint: '',
        activityMoney: '',
        telephone: '',
        closeTime: '',
      }
    },
    // 跳转
    jump() {
      this.$router.push({
        name: 'yhMemberActivitiesManageList'
      })
    },
    // 提交表单
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '' || this.id === undefined) {
            // 新增
            this.handleCreate()
          } else {
            // 修改
            this.handleUpdate()
          }
        }
      })
    },

    // 处理新增
    handleCreate() {
      if (this.form.gardenIds.includes(0)) {
        this.form.gardenIds.splice(0, 1)
      }
      if (this.form.gardenIds.length < 1) {
        this.$message.error(this.$i18n.t('lang.lab_chooseGarden'))
        return
      } else if (this.beginTimeList[1] < this.form.closeTime) {
        this.$message.error('报名截止时间不得晚于活动截止时间')
        return
      } else if (this.form.image === '') {
        this.$message.error('请上传图片')
        return
      }

      let params = {
        'garden[]': this.form.gardenIds.toString(),
        image: this.form.image,
        name: this.form.name,
        content: this.form.content,
        beginTime: this.beginTimeList[0],
        endTime: this.beginTimeList[1],
        place: this.form.place,
        totalNum: this.form.totalNum,
        activityPoint: this.form.activityPoint,
        activityMoney: this.form.activityMoney,
        telephone: this.form.telephone,
        closeTime: this.form.closeTime,
      }

      let loading = this.$loading()
      this.$post(`/gardenShopActivity`, params)
        .then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_save_success'))
            this.$router.push({ name: 'yhMemberActivitiesManageList' })
          } else {
            this.$message.error(res.errMsg)
          }
        })
        .catch(error => {
          this.handleError(loading, error)
        })
    },

    // 处理更新
    handleUpdate() {
      if (this.form.gardenId === 0) {
        this.$message.error(this.$i18n.t('lang.lab_chooseGarden'))
        return
      }

      let params = {
        gardenId: this.form.gardenId,
        image: this.form.image,
        name: this.form.name,
        content: this.form.content,
        beginTime: this.beginTimeList[0],
        endTime: this.beginTimeList[1],
        place: this.form.place,
        totalNum: this.form.totalNum,
        activityPoint: this.form.activityPoint,
        activityMoney: this.form.activityMoney,
        telephone: this.form.telephone,
        closeTime: this.form.closeTime,
      }

      let loading = this.$loading()
      this.$patch(`/gardenShopActivity/${this.id}`, params)
        .then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_save_success'))
            this.$router.push({ name: 'yhMemberActivitiesManageList' })
          } else {
            this.$message.error(res.errMsg)
          }
        })
        .catch(error => {
          this.handleError(loading, error)
        })
    },

    // 统一错误处理
    handleError(loading, error) {
      console.log(error)
      loading.close()
      this.$message.error(error || '操作失败，请重试')
    }
  },
  // 调用富文本方法生效
  mounted() {
    addQuillTitle()
  }
}
</script>

<style lang="scss">
.yhMemberActivitiesManageAdd {
  .input {
    width: 50%;
  }

  .el-form-item__content {
    width: 60vw !important;
  }

  .select {
    width: 50%;
  }
  .date-picker-width {
    width: 350px;
  }
}
</style>